import {connect} from 'react-redux'
import styles from './ActionBar.css'
import {DropdownButton, MenuItem} from 'react-bootstrap'
import {customersRequest, setCustomers} from 'actions/customers/list'
import {Field, reduxForm} from 'redux-form'
import SearchBar from 'components/Fields/ReduxForm/SearchBar'
import {showPageLoadingSpinner} from 'actions/loadingSpinner'
import MenuTitle from 'components/MenuTitle'
import LoyaltyBanner from './LoyaltyBanner'
import {isFullSiteMode} from 'utils/fullSite'

class ActionBar extends React.Component {
  render () {
    let {onClickImport, onClickExport} = this.props

    return (
      <div>
        <MenuTitle menuTitle='Customers List' />
        { !isFullSiteMode() &&
          <div className='col-sm-6 col-xs-4 pull-right col-md-6 action-customer-list'>
            <div className='pull-right'>
              <DropdownButton title='Import / Export' bsStyle='primary'>
                <MenuItem onSelect={onClickImport}>Import Customer</MenuItem>
                <MenuItem divider />
                <MenuItem onSelect={onClickExport}>Export Customer</MenuItem>
              </DropdownButton>
            </div>
          </div>
        }
        <LoyaltyBanner />
        <div className={styles.wrapper}>
          <div className='row'>
            <div className='col-sm-3 col-xs-4 search-customer-list'>
              <Field
                name='keyword'
                component={SearchBar}
                onChange={this._onChangeKeyword}
                placeholder='Name, email, phone'
                className='searchbar-customerlist'
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  _onChangeKeyword = (event, keyword) => {
    const {dispatch} = this.props
    dispatch(setCustomers([]))
    dispatch(showPageLoadingSpinner(true))
    dispatch(customersRequest({
      page: 1,
      keyword: keyword.trim()
    }, []))
  }
}

ActionBar.propTypes = {
}

const mapForm = {
  form: 'search'
}

function mapStateToProps (state) {
  return {
    data: {
      customers: {
        list: state.customers.list
      }
    }
  }
}
export default connect(mapStateToProps)(reduxForm(mapForm)(ActionBar))



// WEBPACK FOOTER //
// ./app/pages/Customers/CustomerList/ListNonLoyalty/ActionBar/ActionBar.js